import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Pause, Volume2, VolumeX, X, SkipBack, SkipForward } from 'lucide-react';
import { useApp, fmtTime } from '../context/AppContext';
import { useCatalog } from '../context/CatalogContext';

export default function MiniPlayer() {
  const { audio, toggleAudio, seekAudio, setAudioVolume, closeAudio } = useApp();
  const { byId } = useCatalog();
  if (!audio.episode) return null;
  const pod = byId(audio.podcastId);
  const pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
  return (
    <div className="fixed left-0 right-0 bottom-0 lg:bottom-0 z-[70] bg-[#0B0A0E]/90 backdrop-blur-md border-t border-[#26212F] shadow-[0_-6px_20px_rgba(40,20,80,0.08)]" style={{ bottom: 0 }} data-testid="mini-player">
      <div className="h-[66px] flex items-center gap-4 px-4 lg:px-6 mb-[56px] lg:mb-0">
        <Link to={`/podcasts/${pod?.id}`} className="flex items-center gap-3 min-w-0 w-[260px]">
          <img src={audio.episode.image} alt="" className="w-11 h-11 rounded-md object-cover" />
          <div className="min-w-0">
            <div className="text-[13px] font-semibold truncate">{audio.episode.title}</div>
            <div className="text-[11.5px] text-[#C7C4CB] truncate">{pod?.title} &bull; {pod?.host}</div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <button onClick={() => seekAudio(Math.max(0, audio.currentTime - 15))} className="text-[#C7C4CB] hover:text-[#FFFFFF]" aria-label="Back 15s"><SkipBack size={18} /></button>
          <button onClick={toggleAudio} className="w-9 h-9 rounded-full bg-[#8B2CFF] text-white flex items-center justify-center hover:scale-105 transition shadow-md shadow-[#8B2CFF]/30" data-testid="mini-player-toggle" aria-label="Play/Pause">
            {audio.playing ? <Pause size={16} fill="currentColor" /> : <Play size={16} fill="currentColor" className="ml-0.5" />}
          </button>
          <button onClick={() => seekAudio(Math.min(audio.duration, audio.currentTime + 30))} className="text-[#C7C4CB] hover:text-[#FFFFFF]" aria-label="Forward 30s"><SkipForward size={18} /></button>
        </div>
        <div className="flex-1 flex items-center gap-3 min-w-0">
          <span className="text-[11px] text-[#C7C4CB] w-10 text-right tabular-nums">{fmtTime(audio.currentTime)}</span>
          <div className="relative flex-1 h-4 flex items-center group">
            <div className="absolute left-0 right-0 h-[3px] rounded bg-[#2C2637]" />
            <div className="absolute left-0 h-[3px] rounded" style={{ width: `${pct}%`, background: 'linear-gradient(90deg,#A855F7,#8B2CFF)' }} />
            <input type="range" min={0} max={audio.duration || 0} step={1} value={audio.currentTime} onChange={(e) => seekAudio(Number(e.target.value))} className="absolute inset-0 w-full opacity-0 cursor-pointer" aria-label="Seek" />
          </div>
          <span className="text-[11px] text-[#C7C4CB] w-10 tabular-nums">{fmtTime(audio.duration)}</span>
        </div>
        <div className="hidden md:flex items-center gap-2 w-[130px]">
          <button onClick={() => setAudioVolume(audio.volume > 0 ? 0 : 0.8)} className="text-[#C7C4CB] hover:text-[#FFFFFF]">{audio.volume > 0 ? <Volume2 size={18} /> : <VolumeX size={18} />}</button>
          <input type="range" min={0} max={1} step={0.02} value={audio.volume} onChange={(e) => setAudioVolume(Number(e.target.value))} className="player-range light" aria-label="Volume" />
        </div>
        <button onClick={closeAudio} className="text-[#C7C4CB] hover:text-[#FFFFFF]" aria-label="Close player" data-testid="mini-player-close"><X size={18} /></button>
      </div>
    </div>
  );
}
